import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { CommonService } from '../../Services/Common/common.service'

@Component({
  selector: 'app-Header',
  templateUrl: './Header.component.html',
  styleUrls: ['./Header.component.css']
})
export class HeaderComponent implements OnInit {

  RazaoSocial: string;
  Email:string;
  Telefono: string;
  imagePath: string;
  
  searchForm = new FormGroup({
    search: new FormControl()
  })

  constructor(private commonService: CommonService) { }

  ngOnInit() {
    this.commonService.razaoSocialChange.subscribe(
      change => {
        this.RazaoSocial = change}
    )
    this.commonService.telefonoChange.subscribe(
      change => {
        this.Telefono = change}
    )
    this.commonService.emailChange.subscribe(
      change => {
        this.Email = change}
    )
    this.commonService.imagePathChange.subscribe(
      change => {
        this.imagePath = change}
    )
  }

}
